angular.module("vgresiduos").controller("DestinationSlipCtrl", [
	"$rootScope",
	"$scope",
	"$state",
	"dialogService",
	function ($rootScope, $scope, $state, dialogService) {
		"use strict";
		$scope.labels = $rootScope.labels;

		$scope.isCurrentStep = function (step) {
			return step.Id == $scope.destinationConfig.currentStepPointer && !$scope.isCurrentStageCompleted();
		};

		$scope.isStepAvailable = function (step) {
			return step.Id <= $scope.destinationConfig.enabledStepPointer && !$scope.isCurrentStageCompleted();
		};

		$scope.toStep = function (step) {
			if (!$scope.isStepAvailable(step)) {
				return;
			}
			$scope.destinationConfig.currentStepPointer = step.Id;
		};

		$scope.showValidationPopup = function () {
			return $scope.validations.length ? true : false;
		};

		$scope.getNotificationLabel = function (notification) {
			return $scope.labels.DISPOSAL_NOTIFICATIONS[notification.Notification];
		};

		$scope.openDisposalReportsPopup = function () {
			const params = {
				disposalId: $scope.destinationModel.Id
			};

			dialogService
				.showDialogFromTemplateV2(
					"views/destination/popups/disposalReportsPopup/disposalReportsPopup_template.html",
					"DisposalReportsPopupCtrl",
					"#large-popup",
					params,
					true
				)
				.then();
		};

		$scope.openDisposalDetailsPage = function () {
			$state.go("disposal", {
				id: $scope.destinationModel.Id
			});
		};

		$scope.openDisposalPendenciesPopup = function () {
			const dialog = dialogService
				.showDialogFromTemplateWithScope(
					null,
					"views/destination/popups/disposalPendenciesPopup/disposalPendenciesPopup_template.html",
					"DisposalPendenciesPopupCtrl",
					$scope,
					"#disposal-popup-small",
					false,
					function () {}
				)
				.then(
					function () {},
					function () {}
				);
			return ($scope.dialog = dialog);
		};

		$scope.getTitleRouter = function () {
			if ($scope.destinationModel.CanGenerateMtr) {
				return $scope.labels.MANAGE_DISPOSAL_INTEGRATIONS;
			} else {
				return $scope.labels.MANAGE_DISPOSAL;
			}
		};

		$scope.openValidationPopup = function () {
			const dialog = dialogService
				.showDialogFromTemplateWithScope(
					null,
					"views/destination/popups/disposalValidationPopup/disposalValidationPopup_template.html",
					"DisposalValidationPopupCtrl",
					$scope,
					"#disposal-popup-small",
					false,
					function () {}
				)
				.then(
					function () {},
					function () {}
				);
			return ($scope.dialog = dialog);
		};

		$scope.showPendencyPopup = function () {
			return !isExecutingSolicitationStage();
		};

		$scope.getStatusChipClass = function () {
			switch ($scope.readOnlyModel.Status) {
				case Vgr.enumerations.destination.status.Canceled:
					return "canceled";
				case Vgr.enumerations.destination.status.Finalized:
					return "finalized";
				default:
					return "default";
			}
		};

		function isExecutingSolicitationStage() {
			return (
				$scope.destinationConfig.currentStage.Id == $scope.stagesEnum.Solicitation && !$scope.isCurrentStageReview()
			);
		}
	}
]);
